
<script>
	
</script>


	<main> 
		<section class="conteudo">
		<h1>Suporte</h1>

			<h2>Encontre aqui suas dúvidas sobre o Jogo da Velha:</h2>

			<h3>1. Como jogar:</h3>
			<p>O jogo da velha é uma brincadeira antiga, clássica e simples — que só precisa de duas pessoas para o jogo começar. Ele é um jogo de "soma zero", ou seja, duas pessoas igualmente habilidosas nunca conseguem derrotar uma à outra. No entanto, se você seguir as dicas e estratégias, vai ter muito mais chances de ser vitorioso nas partidas.</p>

			<h3>2. Objetivo do jogo: </h3>
			<p>O principal objetivo do jogo da velha é fazer uma sequência de três símbolos iguais, seja em linha vertical, horizontal ou diagonal, enquanto tenta prever o movimento do adversário. Sendo uma boa oportunidade para estimular o raciocínio lógico, aprender a formar sequência e a ter paciência.</p>

			<h3>3. Melhor estratégia para jogar: </h3>
			<p>Marque um dos cantos e, dependendo do que seu oponente fizer, marque outro canto, e você estará com a vitória nas mãos. Por exemplo, se você faz o X no canto inferior esquerdo, e ele coloca o O no canto inferior direito, você deve responder com um X no canto superior esquerdo.</p>
		</section>
	</main>


<style>
	/* your styles go here */
main {
    background-color: rgba(0, 0, 0, 0.849);
    padding: 5px 40px;
    margin-top: 20px;
    margin-right: 25%;
    margin-left: 25%;
    border-radius: 10px;
    font-family: 'Roboto', sans-serif;
}

.conteudo {
    color: white;
    margin: auto;
    width: 100%;
    height: 100%;  
    text-align:justific;
    font-size: 18px;
    font-family: 'Roboto', sans-serif;
   
}

.conteudo h1 {
    font-size: xx-large;
    text-align: center;
    font-weight: bold;
    font-variant: small-caps;
    font-family: 'Roboto', sans-serif;
}

.conteudo h2 {
    font-size: 17px;
    font-family: 'Roboto', sans-serif;
}

.conteudo h3 {
    font-size: 20px;
    text-align: left;
    font-family: 'Roboto', sans-serif;
}

.conteudo p {
    text-align: justify;
    font-size: 18px;
    font-family: 'Roboto', sans-serif;
}

@media screen and (max-width: 576px){
    main {
        margin-left: 45px;
        margin-right: 45px;
        padding-left: 30px;
        padding-right: 30px;
    }
}
</style>